export const AUTH_TOKEN = "ARLABS_PANEL_AUTH_TOKEN";
export const SETTINGS = "ARLABS_PANEL_SETTINGS";
export const PARTNER = "ARLABS_PANEL_PARTNER";
